/* SLOVENŠTINA PRO INTERNÍ STRÁNKY — doplněk sdíleného slovníku UI (TL), klíčem je ČESKÝ TEXT.
 *
 * Vzniklo 25. 10. 2026 (velký test SK, tým „sk-interni“): slovenský poradce
 * (tenant SK, jazyk sk) viděl česky Projekt 100 (+ průvodce), Finanční mapu
 * klienta, Leadovač a drobnosti ve Skriptech, Metodice a Zrcadle volání.
 * Dlouhé texty skriptů, akvizice a metodiky NEJSOU tady, ale v samostatných
 * datových souborech (data/callScriptsSk.js, data/acquisitionDataSk.js,
 * data/akademie/metodikaSk.js) — klíčem by tu byly celé odstavce.
 *
 * Vlastní soubor, protože prekladyUI.data.js souběžně mění jiné týmy; řádky
 * z ostatních slovníků mají přednost (rozbalují se až za tímto).
 *
 * Stránky: `sk` (chybějící jazyk = čeština, dnešní stav). Popisky ikonových
 * tlačítek (aria-label) mají všech pět jazyků.
 * Řádky s „Kč“ jsou překlad textů pro ČESKÝ trh (tenant CZ se slovenštinou);
 * slovenský tenant dostane jiný klíč s eury (CRMReferralsPage → POPIS_SK_TRH).
 * {jmeno}, {n}, {mena}… dosazuje volající přes .replace().
 * ⚠️ ŽÁDNÉ ASCII " UVNITŘ TEXTU (rozbíjí JS string, viz CLAUDE.md).
 */
export const PREKLADY_SK2 = {
  /* ── Popisky ikonových tlačítek (aria-label/title) — 5 jazyků ── */
  "Smazat řádek": { sk: "Zmazať riadok", en: "Delete row", uk: "Видалити рядок", vi: "Xóa dòng" },
  "Odebrat osobu": { sk: "Odobrať osobu", en: "Remove person", uk: "Видалити особу", vi: "Xóa người" },
  "Zpět do návrhu": { sk: "Späť do návrhu", en: "Back to the proposal", uk: "Назад до пропозиції", vi: "Quay lại đề xuất" },
  "Krok": { sk: "Krok", en: "Step", uk: "Крок", vi: "Bước" },
  "Odebrat navýšení": { sk: "Odobrať navýšenie", en: "Remove increase", uk: "Видалити збільшення", vi: "Xóa khoản tăng" },
  "Otevřít téma": { sk: "Otvoriť tému", en: "Open topic", uk: "Відкрити тему", vi: "Mở chủ đề" },
  "Které kontakty": { sk: "Ktoré kontakty", en: "Which contacts", uk: "Які контакти", vi: "Liên hệ nào" },

  /* ── Skripty & námitky (CRMScriptsPage, CRMCallsPage) ── */
  "Zkopírováno — vlož do SMS/mailu": { sk: "Skopírované — vlož do SMS/mailu" },
  "Kopírování selhalo": { sk: "Kopírovanie zlyhalo" },
  "Call scripty podle typu kontaktu": { sk: "Call skripty podľa typu kontaktu" },
  "Banka námitek": { sk: "Banka námietok" },
  "Hledat námitku...": { sk: "Hľadať námietku..." },
  "Odpověď": { sk: "Odpoveď" },
  "Co odpovědět na námitku": { sk: "Čo odpovedať na námietku" },

  /* ── Projekt 100 (CRMLeadsPage) ── */
  "Jméno je povinné": { sk: "Meno je povinné" },
  "Tohle číslo už máš u:": { sk: "Toto číslo už máš pri:" },
  "jiného kontaktu": { sk: "inom kontakte" },
  "Kontakt upraven": { sk: "Kontakt upravený" },
  "Kontakt přidán": { sk: "Kontakt pridaný" },
  "Chyba při ukládání": { sk: "Chyba pri ukladaní" },
  "Upravit kontakt": { sk: "Upraviť kontakt" },
  "Chyba při načítání": { sk: "Chyba pri načítaní" },
  "Přesunout kontakt {jmeno} do koše? Kdykoli ho lze obnovit v Klienti → Koš.": { sk: "Presunúť kontakt {jmeno} do koša? Kedykoľvek ho obnovíš v Klienti → Kôš." },
  "Kontakt je v koši — obnovíš ho v Klienti → Koš": { sk: "Kontakt je v koši — obnovíš ho v Klienti → Kôš" },
  "Chyba při mazání": { sk: "Chyba pri mazaní" },
  "Zatím dnes žádný": { sk: "Dnes zatiaľ žiadny" },
  "Vyplnit seznam — průvodce krok za krokem": { sk: "Vyplniť zoznam — sprievodca krok za krokom" },
  "Provedu tě 11 okruhy (škola, práce, rodina…). U každého jen jméno a Enter. Ideální pro start.": { sk: "Prevediem ťa 11 okruhmi (škola, práca, rodina…). Pri každom len meno a Enter. Ideálne na štart." },
  "Spustit →": { sk: "Spustiť →" },
  "Hledat jméno, telefon, město…": { sk: "Hľadať meno, telefón, mesto…" },
  "Všechny okruhy": { sk: "Všetky okruhy" },
  "Všechny kontakty": { sk: "Všetky kontakty" },
  "11 kategorií kde hledat lidi do Projektu 100 (tipy)": { sk: "11 kategórií, kde hľadať ľudí do Projektu 100 (tipy)" },
  "Zatím žádný kontakt.": { sk: "Zatiaľ žiadny kontakt." },
  "Přidat první": { sk: "Pridať prvý" },
  "plnění": { sk: "plnenie" },
  "Dnešní dávka": { sk: "Dnešná dávka" },
  "5 lidí, kterým": { sk: "5 ľudí, ktorým" },
  "zavoláš · zaměřit + odbít": { sk: "zavoláš · zamerať sa + vybaviť" },
  "5 / den": { sk: "5 / deň" },
  "doporučení": { sk: "odporúčaní" },
  // Popisky formuláře kontaktu (Field → TL(label))
  "Věk": { sk: "Vek" },
  "Činnost / povolání": { sk: "Činnosť / povolanie" },
  "Kategorie klienta (A/B/C)": { sk: "Kategória klienta (A/B/C)" },
  "P100 kategorie": { sk: "P100 kategória" },
  "Fáze pipeline": { sk: "Fáza pipeline" },
  "Doporučení — kolik získal": { sk: "Odporúčania — koľko získal" },
  // Kategorie Projektu 100 a tipy (data/crmData.js — P100_CATEGORIES)
  "Ze školy (ZŠ, SŠ, VŠ, vojna)": { sk: "Zo školy (ZŠ, SŠ, VŠ, vojenčina)" },
  "Ze svého adresáře": { sk: "Zo svojho adresára" },
  "Od svých známých": { sk: "Od svojich známych" },
  "Z klubových seznamů": { sk: "Z klubových zoznamov" },
  "Z telefonních seznamů": { sk: "Z telefónnych zoznamov" },
  "Z dokumentů školského řádu": { sk: "Zo školských dokumentov" },
  "Z matričního úřadu": { sk: "Z matričného úradu" },
  "Z minulého zaměstnání": { sk: "Z minulého zamestnania" },
  "Bývalé kolegy a kolegyně": { sk: "Bývalých kolegov a kolegyne" },
  "Dřívější zákazníky a konkurenty": { sk: "Bývalých zákazníkov a konkurentov" },
  "Členy komor a sdružení": { sk: "Členov komôr a združení" },
  "Bývalé účastníky seminářů, kurzů a školení": { sk: "Bývalých účastníkov seminárov, kurzov a školení" },
  "Přes partnera a děti": { sk: "Cez partnera a deti" },
  "Kolegy a spolužáky partnera": { sk: "Kolegov a spolužiakov partnera" },
  "Organizace k nimž partner patří": { sk: "Organizácie, do ktorých partner patrí" },
  "Okruh známých mého partnera": { sk: "Okruh známych môjho partnera" },
  "Rodiče spolužáků a kamarádů dětí": { sk: "Rodičov spolužiakov a kamarátov detí" },
  "Známé a přátele našich dětí": { sk: "Známych a priateľov našich detí" },
  "Vychovatele a učitele dětí": { sk: "Vychovávateľov a učiteľov detí" },
  "Příbuzní": { sk: "Príbuzní" },
  "Z matčiny strany": { sk: "Z maminej strany" },
  "Z otcovy strany": { sk: "Z otcovej strany" },
  "Z partnerovy strany": { sk: "Z partnerovej strany" },
  "Ze strany přátel a známých": { sk: "Zo strany priateľov a známych" },
  "Sport, koníčky a okolí": { sk: "Šport, koníčky a okolie" },
  "Spoluhráče, členy spolků a sponzory": { sk: "Spoluhráčov, členov spolkov a sponzorov" },
  "Protihráče, rozhodčí": { sk: "Protihráčov, rozhodcov" },
  "Lidi se stejnými koníčky (IT, hudba, divadlo, foto)": { sk: "Ľudí s rovnakými koníčkami (IT, hudba, divadlo, foto)" },
  "Lidi z obchodů, řemesel a služeb": { sk: "Ľudí z obchodov, remesiel a služieb" },
  "Bydliště — minulé a současné": { sk: "Bydlisko — minulé a súčasné" },
  "Bývalé sousedy a přátele": { sk: "Bývalých susedov a priateľov" },
  "Současné sousedy a přátele": { sk: "Súčasných susedov a priateľov" },
  "Majitele pozemků a domů": { sk: "Majiteľov pozemkov a domov" },
  "Pronajímatele a makléře": { sk: "Prenajímateľov a maklérov" },
  "Dovolené": { sk: "Dovolenky" },
  "Pracovníky CK, průvodce": { sk: "Pracovníkov CK, sprievodcov" },
  "Gastronomy a hoteliéry": { sk: "Gastronómov a hoteliérov" },
  "Obsluhující personál": { sk: "Obsluhujúci personál" },
  "Známé z dovolené": { sk: "Známych z dovolenky" },
  "Mám vlastní dům / byt": { sk: "Mám vlastný dom / byt" },
  "Architekty, stavitele, dodavatele": { sk: "Architektov, staviteľov, dodávateľov" },
  "Bývalého majitele, nájemníky, makléře, notáře": { sk: "Bývalého majiteľa, nájomníkov, maklérov, notárov" },
  "Listonoše, daňové poradce, právníka": { sk: "Poštára, daňových poradcov, právnika" },
  "Instalatéry, údržbáře, malíře, elektrikáře, ostatní řemeslníky": { sk: "Inštalatérov, údržbárov, maliarov, elektrikárov, ostatných remeselníkov" },
  "Dobročinná práce / organizace / kluby": { sk: "Dobročinná práca / organizácie / kluby" },
  "Kolegy, sponzory, předsedy, členy": { sk: "Kolegov, sponzorov, predsedov, členov" },
  "Chráněnce": { sk: "Chránencov" },
  "Společenské události a oslavy": { sk: "Spoločenské udalosti a oslavy" },
  "Z narozenin, svátků, jubileí": { sk: "Z narodenín, menín, jubileí" },
  "Z večírků, svateb": { sk: "Z večierkov, svadieb" },
  "Z dětských slavností a školních oslav": { sk: "Z detských slávností a školských osláv" },
  "Denní kontakty": { sk: "Denné kontakty" },
  "Prodavače potravin": { sk: "Predavačov potravín" },
  "Zaměstnance čistíren a prádelen": { sk: "Zamestnancov čistiarní a práčovní" },
  "Obuvníky a prodavače textilu": { sk: "Obuvníkov a predavačov textilu" },
  "Kadeřníky, pekaře, řezníky, trafikanty": { sk: "Kaderníkov, pekárov, mäsiarov, trafikantov" },
  "Doktory, zubaře a lékárníky": { sk: "Doktorov, zubárov a lekárnikov" },
  "Pracovníky bank a veřejných institucí": { sk: "Pracovníkov bánk a verejných inštitúcií" },
  // Vztah (RELATIONSHIP_TYPES)
  "Přítel": { sk: "Priateľ" },
  "Známý": { sk: "Známy" },
  "Soused": { sk: "Sused" },
  "Žádný": { sk: "Žiadny" },

  /* ── Projekt 100 — průvodce (components/leads/Projekt100Pruvodce.js) ── */
  "Podobné jméno už v seznamu je:": { sk: "Podobné meno už v zozname je:" },
  "Nepovedlo se uložit — zkus to ještě jednou": { sk: "Nepodarilo sa uložiť — skús to ešte raz" },
  "průvodce": { sk: "sprievodca" },
  "Napíšeme spolu tvůj seznam 100 lidí": { sk: "Napíšeme spolu tvoj zoznam 100 ľudí" },
  "Provedu tě okruh po okruhu. U každého jen napíšeš **jméno** (a když víš, i **telefon**) a jedeš dál. Nic víc teď neřešíš.": { sk: "Prevediem ťa okruh po okruhu. Pri každom len napíšeš **meno** (a keď vieš, aj **telefón**) a ideš ďalej. Nič viac teraz neriešiš." },
  "Proč to děláš": { sk: "Prečo to robíš" },
  "Tvůj seznam je tvůj **základ**. Není to seznam lidí na otravování — jsou to lidi, kterým můžeš **pomoct**, aby na peníze nebyli sami.": { sk: "Tvoj zoznam je tvoj **základ**. Nie je to zoznam ľudí na otravovanie — sú to ľudia, ktorým môžeš **pomôcť**, aby na peniaze neboli sami." },
  "Neboj se": { sk: "Neboj sa" },
  "Ty **nenabízíš, ty pomáháš**. Líp ať to slyší od tebe — někoho, komu věří — než od cizího. A líp se to učí na lidech, co tě mají rádi.": { sk: "Ty **neponúkaš, ty pomáhaš**. Radšej nech to počujú od teba — od niekoho, komu veria — než od cudzieho. A lepšie sa to učí na ľuďoch, ktorí ťa majú radi." },
  "„Ten nebude mít zájem“ — **napiš ho stejně**. Teď jde o množství, vybírat budeš až potom. Nech rozhodnutí na nich.": { sk: "„Ten nebude mať záujem“ — **napíš ho rovnako**. Teraz ide o množstvo, vyberať budeš až potom. Nechaj rozhodnutie na nich." },
  "Je to soukromé": { sk: "Je to súkromné" },
  "Seznam vidíš **jen ty**. Nikomu se teď nevolá — jen píšeš jména. Volat budeš, až budeš chtít a připravený/á.": { sk: "Zoznam vidíš **len ty**. Nikomu sa teraz nevolá — len píšeš mená. Volať budeš, až keď budeš chcieť a budeš pripravený/á." },
  "Jdeme na to": { sk: "Ideme na to" },
  "11 okruhů · zabere pár minut · kdykoliv můžeš skončit": { sk: "11 okruhov · zaberie pár minút · kedykoľvek môžeš skončiť" },
  "Koho si vybavíš?": { sk: "Na koho si spomenieš?" },
  "V tomhle okruhu:": { sk: "V tomto okruhu:" },
  "Přeskočit": { sk: "Preskočiť" },
  "Dokončit": { sk: "Dokončiť" },
  "Další okruh": { sk: "Ďalší okruh" },
  "Napsal jsi": { sk: "Napísal si" },
  "Celkem máš v Projektu 100 **{n}** z {cil}.": { sk: "Celkovo máš v Projekte 100 **{n}** z {cil}." },
  "Ještě **{n}** a máš plný seznam — můžeš se kdykoliv vrátit.": { sk: "Ešte **{n}** a máš plný zoznam — môžeš sa kedykoľvek vrátiť." },
  "Co dál": { sk: "Čo ďalej" },
  "V tabulce si u jmen časem doplníš **kategorii A/B/C** a poznámky.": { sk: "V tabuľke si pri menách časom doplníš **kategóriu A/B/C** a poznámky." },
  "Všichni jsou v **Zrcadle volání**. **Dnešní dávka** = prvních 5, kdo čeká nejdéle.": { sk: "Všetci sú v **Zrkadle volania**. **Dnešná dávka** = prvých 5, ktorí čakajú najdlhšie." },
  "Nevíš jak začít hovor? Mrkni do **Akademie → Navolávání**.": { sk: "Nevieš, ako začať hovor? Pozri sa do **Akadémie → Skripty & Námietky**." },
  "Projít okruhy znovu": { sk: "Prejsť okruhy znova" },
  "Zavřít a uvidět seznam": { sk: "Zavrieť a pozrieť zoznam" },
  "člověka": { sk: "človeka" },
  "lidi": { sk: "ľudí" },
  "lidí": { sk: "ľudí" },
  // Připomínací otázky okruhů (JOGGERS)
  "Spolužáci ze základky": { sk: "Spolužiaci zo základky" },
  "Parta ze střední": { sk: "Partia zo strednej" },
  "Lidi z výšky / kolejí": { sk: "Ľudia z vysokej / internátu" },
  "Kámoši z vojny": { sk: "Kamaráti z vojenčiny" },
  "S kým jsi seděl v lavici": { sk: "S kým si sedel v lavici" },
  "Kdo byl třídní šašek": { sk: "Kto bol triedny šašo" },
  "Bývalí kolegové": { sk: "Bývalí kolegovia" },
  "Šéf / podřízení": { sk: "Šéf / podriadení" },
  "Zákazníci z minula": { sk: "Zákazníci z minulosti" },
  "Lidi z porad a školení": { sk: "Ľudia z porád a školení" },
  "Konkurence, co znáš": { sk: "Konkurencia, ktorú poznáš" },
  "Kolegové partnera/ky": { sk: "Kolegovia partnera/ky" },
  "Spolužáci partnera/ky": { sk: "Spolužiaci partnera/ky" },
  "Rodiče dětí z kroužků": { sk: "Rodičia detí z krúžkov" },
  "Učitelé a vychovatelé": { sk: "Učitelia a vychovávatelia" },
  "Kámoši tvých dětí a jejich rodiče": { sk: "Kamaráti tvojich detí a ich rodičia" },
  "Z mámy strany": { sk: "Z maminej strany" },
  "Z táty strany": { sk: "Z otcovej strany" },
  "Bratranci, sestřenice": { sk: "Bratranci, sesternice" },
  "Strejdové, tety": { sk: "Strýkovia, tety" },
  "Kmotři a kmotřenci": { sk: "Krstní rodičia a krstniatka" },
  "Spoluhráči z týmu": { sk: "Spoluhráči z tímu" },
  "Soupeři, co znáš": { sk: "Súperi, ktorých poznáš" },
  "Trenér / rozhodčí": { sk: "Tréner / rozhodca" },
  "Lidi ze stejného koníčku": { sk: "Ľudia s rovnakým koníčkom" },
  "Parta z posilovny / běhání": { sk: "Partia z posilňovne / behu" },
  "Současní sousedi": { sk: "Súčasní susedia" },
  "Bývalí sousedi": { sk: "Bývalí susedia" },
  "Lidi z baráku / ulice": { sk: "Ľudia z bytovky / ulice" },
  "Správce / domovník": { sk: "Správca / domovník" },
  "Majitel bytu / makléř": { sk: "Majiteľ bytu / maklér" },
  "Známí z dovolené": { sk: "Známi z dovolenky" },
  "Průvodce / animátor": { sk: "Sprievodca / animátor" },
  "Personál z hotelu": { sk: "Personál z hotela" },
  "Lidi z výletů a zájezdů": { sk: "Ľudia z výletov a zájazdov" },
  "Řemeslníci (instalatér, elektrikář…)": { sk: "Remeselníci (inštalatér, elektrikár…)" },
  "Stavbař / architekt": { sk: "Stavbár / architekt" },
  "Realiťák / notář": { sk: "Realitný maklér / notár" },
  "Listonoš": { sk: "Poštár" },
  "Údržbář, malíř": { sk: "Údržbár, maliar" },
  "Lidi ze spolku / klubu": { sk: "Ľudia zo spolku / klubu" },
  "Dobrovolníci": { sk: "Dobrovoľníci" },
  "Sponzoři": { sk: "Sponzori" },
  "Předseda a členové": { sk: "Predseda a členovia" },
  "Z poslední oslavy / svatby": { sk: "Z poslednej oslavy / svadby" },
  "Z narozenin a jubileí": { sk: "Z narodenín a jubileí" },
  "Z firemního večírku": { sk: "Z firemného večierka" },
  "Z dětských slavností": { sk: "Z detských slávností" },
  "Kadeřník / holič": { sk: "Kaderník / holič" },
  "Doktor, zubař, lékárník": { sk: "Doktor, zubár, lekárnik" },
  "Prodavač, pekař, řezník": { sk: "Predavač, pekár, mäsiar" },
  "Člověk z banky / pošty": { sk: "Človek z banky / pošty" },
  "Barista z oblíbené kavárny": { sk: "Barista z obľúbenej kaviarne" },

  /* ── Finanční mapa klienta (pages/FinancniMapaPage.js) ── */
  "Klienta se nepodařilo načíst": { sk: "Klienta sa nepodarilo načítať" },
  "Finanční mapa uložena": { sk: "Finančná mapa uložená" },
  "Načítám mapu…": { sk: "Načítavam mapu…" },
  "Modelovat v kalkulačce": { sk: "Modelovať v kalkulačke" },
  "Pozor na měnu.": { sk: "Pozor na menu." },
  "Tahle analýza je z doby, kdy se měna do dat neukládala — čteme ji jako {mena}. Účet dnes pracuje v {ucet}.": { sk: "Táto analýza je z obdobia, keď sa mena do dát neukladala — čítame ju ako {mena}. Účet dnes pracuje v {ucet}." },
  "Analýza je uložená v {mena}, účet dnes pracuje v {ucet}.": { sk: "Analýza je uložená v {mena}, účet dnes pracuje v {ucet}." },
  "Částky se **nepřepočítávají** a zůstávají tak, jak byly zadané — aplikace nezná kurz. Než čísla ukážeš klientovi, ověř je.": { sk: "Sumy sa **neprepočítavajú** a zostávajú tak, ako boli zadané — aplikácia nepozná kurz. Skôr než čísla ukážeš klientovi, over ich." },
  "Finanční mapa": { sk: "Finančná mapa" },
  "Mapa zachycuje **dnešek**. Budoucnost vyřeší plán. Na konci musí sedět dvě čísla: majetek a volné cash flow.": { sk: "Mapa zachytáva **dnešok**. Budúcnosť vyrieši plán. Na konci musia sedieť dve čísla: majetok a voľné cash flow." },
  "Osobní": { sk: "Osobné" },
  "„Minule jsme se domluvili na 45 minut, já s tím tak počítám. Jak jsi na tom ty?“": { sk: "„Minule sme sa dohodli na 45 minút, ja s tým tak počítam. Ako si na tom ty?“" },
  "Rok narození": { sk: "Rok narodenia" },
  "Děti (počet)": { sk: "Deti (počet)" },
  "Věk:": { sk: "Vek:" },
  "Očekávání a hodnoty (zapisuj doslova!)": { sk: "Očakávania a hodnoty (zapisuj doslova!)" },
  "„Co je tvoje hlavní očekávání od dnešní schůzky?“ → zopakuj a dodej: „Mým cílem je podívat se, co už děláš dobře, kde možná přicházíš o peníze a co se dá zlepšit.“": { sk: "„Aké je tvoje hlavné očakávanie od dnešného stretnutia?“ → zopakuj a dodaj: „Mojím cieľom je pozrieť sa, čo už robíš dobre, kde možno prichádzaš o peniaze a čo sa dá zlepšiť.“" },
  "Očekávání klienta": { sk: "Očakávania klienta" },
  "„Čím jsou pro tebe peníze důležité?“ — zopakuj slovo („Svoboda… co znamená svoboda pro tebe?“), doptej se: „Co dalšího tě napadne?“": { sk: "„Prečo sú pre teba peniaze dôležité?“ — zopakuj slovo („Sloboda… čo znamená sloboda pre teba?“), dopýtaj sa: „Čo ďalšie ťa napadne?“" },
  "Co pro klienta znamenají peníze (hodnoty)": { sk: "Čo pre klienta znamenajú peniaze (hodnoty)" },
  "svoboda, jistota, klid…": { sk: "sloboda, istota, pokoj…" },
  "Můstek: „Pokud ti finanční plán pomůže naplnit {hodnoty} — bude to správné řešení?“": { sk: "Mostík: „Ak ti finančný plán pomôže naplniť {hodnoty} — bude to správne riešenie?“" },
  "Cíle (rezerva + renta povinné, max 5 dalších)": { sk: "Ciele (rezerva + renta povinné, max. 5 ďalších)" },
  "„Pojďme na strategické cíle ve struktuře CO – KDY – KOLIK. Co tě napadá jako první?“ Ověř vždy: 1) bydlení 2) vzdělání dětí 3) finanční nezávislost.": { sk: "„Poďme na strategické ciele v štruktúre ČO – KEDY – KOĽKO. Čo ťa napadá ako prvé?“ Over vždy: 1) bývanie 2) vzdelanie detí 3) finančná nezávislosť." },
  "Doporučení: 6× výdaje =": { sk: "Odporúčanie: 6× výdavky =" },
  "Od věku": { sk: "Od veku" },
  "Např. studium dětí": { sk: "Napr. štúdium detí" },
  "Přidat cíl": { sk: "Pridať cieľ" },
  "Finanční majetek (zdroje)": { sk: "Finančný majetok (zdroje)" },
  // Skript ke zdrojům podle ZEMĚ TENANTA: SK (pilíře) / CZ (penzijko)
  "„Nyní známe cíle — pojďme na zdroje pro jejich naplnění. Prvním zdrojem je stavební spoření, využíváš?“ (pořadí: stavební spoření → II. a III. pilíř (DDS) → fondy → účty → hotovost)": { sk: "„Teraz poznáme ciele — poďme na zdroje na ich naplnenie. Prvým zdrojom je stavebné sporenie, využívaš ho?“ (poradie: stavebné sporenie → II. a III. pilier (DDS) → fondy → účty → hotovosť)" },
  "„Nyní známe cíle — pojďme na zdroje pro jejich naplnění. Prvním zdrojem je stavební spoření, využíváš?“ (pořadí: stavebko → penzijko → fondy → účty → hotovost)": { sk: "„Teraz poznáme ciele — poďme na zdroje na ich naplnenie. Prvým zdrojom je stavebné sporenie, využívaš ho?“ (poradie: stavebné sporenie → penzijné sporenie (DPS) → fondy → účty → hotovosť)" },
  "Název (např. ČSOB účet)": { sk: "Názov (napr. účet v ČSOB)" },
  "Měsíčně posílá": { sk: "Mesačne posiela" },
  "Přidat zdroj": { sk: "Pridať zdroj" },
  "Nefinanční majetek (nemovitosti, auta…)": { sk: "Nefinančný majetok (nehnuteľnosti, autá…)" },
  "Např. byt Praha": { sk: "Napr. byt Bratislava" },
  "Přidat majetek": { sk: "Pridať majetok" },
  "Závazky (úvěry)": { sk: "Záväzky (úvery)" },
  "Např. hypotéka": { sk: "Napr. hypotéka" },
  "Zůstatek": { sk: "Zostatok" },
  "Přidat závazek": { sk: "Pridať záväzok" },
  "Splátka hypotéky časem reálně „zlevňuje“ — uvolněný prostor v plánu přesměrujeme na rentu.": { sk: "Splátka hypotéky časom reálne „zlacňuje“ — uvoľnený priestor v pláne presmerujeme na rentu." },
  "Příjmy (čisté měsíčně)": { sk: "Príjmy (čisté mesačne)" },
  "„Dalším zdrojem pro naplnění tvých cílů jsou tvoje příjmy. Kolik máš čistého měsíčně?“ (bonusy = průměr za 2–3 roky)": { sk: "„Ďalším zdrojom na naplnenie tvojich cieľov sú tvoje príjmy. Koľko máš čistého mesačne?“ (bonusy = priemer za 2–3 roky)" },
  "Popis příjmu": { sk: "Popis príjmu" },
  "Pokračuje i v rentě (např. pronájem)": { sk: "Pokračuje aj v rente (napr. prenájom)" },
  "i v rentě": { sk: "aj v rente" },
  "jen do renty": { sk: "len do renty" },
  "Přidat příjem": { sk: "Pridať príjem" },
  "Výdaje (měsíčně, bez splátek a pojistného)": { sk: "Výdavky (mesačne, bez splátok a poistného)" },
  "„Kolik si myslíš, že jste schopni měsíčně ušetřit?“ — NIKDY nepitvej jednotlivé výdaje. Minimální = nezbytné (na rezervu).": { sk: "„Koľko si myslíš, že ste schopní mesačne ušetriť?“ — NIKDY nerozoberaj jednotlivé výdavky. Minimálne = nevyhnutné (na rezervu)." },
  "Popis výdaje": { sk: "Popis výdavku" },
  "Minimální (nezbytné)": { sk: "Minimálne (nevyhnutné)" },
  "Přidat výdaj": { sk: "Pridať výdavok" },
  "Mandatorní výdaje:": { sk: "Mandatórne výdavky:" },
  "rezerva 6× (vč. splátek) =": { sk: "rezerva 6× (vr. splátok) =" },
  "Opakované výdaje (dovolená, auto) patří sem — nejsou to cíle.": { sk: "Opakované výdavky (dovolenka, auto) patria sem — nie sú to ciele." },
  "Pojištění (jen kategorie a platba)": { sk: "Poistenie (len kategória a platba)" },
  "Pojišťovna / produkt": { sk: "Poisťovňa / produkt" },
  "Přidat pojistku": { sk: "Pridať poistku" },
  "Doporučené pojistné částky (počítáme — PLANIQ tohle nemá)": { sk: "Odporúčané poistné sumy (počítame — PLANIQ toto nemá)" },
  "60 % příjmu × {n} let do renty": { sk: "60 % príjmu × {n} rokov do renty" },
  "Smrt": { sk: "Smrť" },
  "let výdajů": { sk: "rokov výdavkov" },
  "dluhy": { sk: "dlhy" },
  "majetek": { sk: "majetok" },
  "Prac. neschopnost": { sk: "Prac. neschopnosť" },
  "（výdaje + splátky − nemocenská 60 %）/ 30 dní": { sk: "（výdavky + splátky − nemocenské 60 %）/ 30 dní" },
  "/den": { sk: "/deň" },
  "/m": { sk: "/mes." },
  "Aktuálně pojištěno": { sk: "Aktuálne poistené" },
  "Pokryto": { sk: "Pokryté" },
  "Chybí": { sk: "Chýba" },
  "Doběh rodiny po úmrtí:": { sk: "Krytie rodiny po úmrtí:" },
  "Poznámky a hodnoty klienta": { sk: "Poznámky a hodnoty klienta" },
  "Co je pro klienta důležité, čeho se bojí, co chce…": { sk: "Čo je pre klienta dôležité, čoho sa bojí, čo chce…" },
  "Volné cash flow / měsíc": { sk: "Voľné cash flow / mesiac" },
  "Příjmy": { sk: "Príjmy" },
  "výdaje": { sk: "výdavky" },
  "pojistné": { sk: "poistné" },
  "spoření": { sk: "sporenie" },
  "Čistý majetek": { sk: "Čistý majetok" },
  "Finanční": { sk: "Finančný" },
  "nefinanční": { sk: "nefinančný" },
  "Kontrola na konci schůzky": { sk: "Kontrola na konci stretnutia" },
  "„**{majetek}** majetku a **{cf}** volných měsíčně — sedí ta dvě čísla?“": { sk: "„**{majetek}** majetku a **{cf}** voľných mesačne — sedia tie dve čísla?“" },
  "3 kontroly konzistence (KFP)": { sk: "3 kontroly konzistencie (KFP)" },
  "Volné CF {cf} není záporné": { sk: "Voľné CF {cf} nie je záporné" },
  "Ročně ušetří ~{castka} — „je to reálné? sedí to s majetkem?“": { sk: "Ročne ušetrí ~{castka} — „je to reálne? sedí to s majetkom?“" },
  "„Je něco důležitého, na co jsem se zapomněl zeptat?“": { sk: "„Je niečo dôležité, na čo som sa zabudol opýtať?“" },
  "Předá: jednorázově": { sk: "Odovzdá: jednorazovo" },
  // Druhy zdrojů a pojistek (uložená hodnota = český klíč)
  "Běžný účet": { sk: "Bežný účet" },
  "Spořicí účet": { sk: "Sporiaci účet" },
  "Penzijko (DIP/DPS)": { sk: "Penzijné sporenie (DPS/DIP)" },
  "DDS (III. pilíř)": { sk: "DDS (III. pilier)" },
  "II. pilíř": { sk: "II. pilier" },
  "Životní (rizikové)": { sk: "Životné (rizikové)" },
  "Životní (investiční)": { sk: "Životné (investičné)" },
  "Úvěrové": { sk: "Úverové" },
  // Výchozí řádky nové mapy
  "Hlavní příjem": { sk: "Hlavný príjem" },
  "Běžné výdaje domácnosti": { sk: "Bežné výdavky domácnosti" },

  /* ── Leadovač (pages/crm/CRMReferralsPage.js) ── */
  "Vytvořené odkazy": { sk: "Vytvorené odkazy" },
  "Vyplněné": { sk: "Vyplnené" },
  "Vytvořit odkaz": { sk: "Vytvoriť odkaz" },
  "Vytvoř první odkaz": { sk: "Vytvor prvý odkaz" },
  "Vyber klienta po IK / podpisu, vygeneruj odkaz a pošli WhatsApp.": { sk: "Vyber klienta po IK / podpise, vygeneruj odkaz a pošli WhatsApp." },
  "Poslat klientovi na WhatsApp s motivační zprávou": { sk: "Poslať klientovi na WhatsApp s motivačnou správou" },
  "Vyber kontakt nebo zadej jméno": { sk: "Vyber kontakt alebo zadaj meno" },
  "Odkaz vytvořen": { sk: "Odkaz vytvorený" },
  "Hledat kontakt...": { sk: "Hľadať kontakt..." },
  "Zadej jméno ručně níže": { sk: "Zadaj meno ručne nižšie" },
  "Zadat jméno ručně": { sk: "Zadať meno ručne" },
  "Tvořím...": { sk: "Vytváram..." },
  "Pro vytvoření Leadovač odkazů si nejdřív nastav": { sk: "Na vytvorenie Leadovač odkazov si najprv nastav" },
  "slug v profilu": { sk: "slug v profile" },
  "Příchozí poptávky": { sk: "Prichádzajúce dopyty" },
  "Zatím žádné. Pošli odkaz prvním 5 klientům a uvidíš.": { sk: "Zatiaľ žiadne. Pošli odkaz prvým 5 klientom a uvidíš." },
  "kdykoliv": { sk: "kedykoľvek" },
  "Vyber kontakt z CRM nebo napiš ručně:": { sk: "Vyber kontakt z CRM alebo napíš ručne:" },
  "Bez kontaktu (jen text)": { sk: "Bez kontaktu (len text)" },
  "Poslední leady": { sk: "Posledné leady" },
  "Aktualizuje se každou minutu": { sk: "Aktualizuje sa každú minútu" },
  "Všechny nové leady": { sk: "Všetky nové leady" },
  "týden": { sk: "týždeň" },
  "celkem": { sk: "celkom" },
  "Zatím žádné leady. Pošli klientovi odkaz a uvidíš.": { sk: "Zatiaľ žiadne leady. Pošli klientovi odkaz a uvidíš." },
  "+ {n} dalších — otevři kartu tématu": { sk: "+ {n} ďalších — otvor kartu témy" },
  "Trychtýř": { sk: "Lievik" },
  "klient vyplnil doporučení": { sk: "klient vyplnil odporúčania" },
  "Tvoje leadovač nástroje": { sk: "Tvoje nástroje Leadovača" },
  "Nejdřív nastav slug v profilu →": { sk: "Najprv nastav slug v profile →" },
  "Otevřeno ↓": { sk: "Otvorené ↓" },
  "Vytvořit odkaz pro klienta →": { sk: "Vytvoriť odkaz pre klienta →" },
  "Detail & sdílet →": { sk: "Detail & zdieľať →" },
  // Názvy a popisy témat (TOPICS, TOPIC_META, NAZVY_TEMAT_BEZ_KARTY)
  "Auta": { sk: "Autá" },
  "Nábor nemovitosti": { sk: "Náber nehnuteľností" },
  "Tipař nemovitostí": { sk: "Tipár nehnuteľností" },
  "Refinancování": { sk: "Refinancovanie" },
  "Finance pro OSVČ": { sk: "Financie pre SZČO" },
  "Rodina s dětmi": { sk: "Rodina s deťmi" },
  "První byt mladým": { sk: "Prvý byt mladým" },
  "Investice pro začátečníky": { sk: "Investície pre začiatočníkov" },
  "Rozvod a finance": { sk: "Rozvod a financie" },
  "Předdůchod a renta": { sk: "Preddôchod a renta" },
  "Pojištění hypotéky": { sk: "Poistenie hypotéky" },
  "Pojištění psů": { sk: "Poistenie psov" },
  "Síla času": { sk: "Sila času" },
  "Kvíz připravenosti": { sk: "Kvíz pripravenosti" },
  "Pojištění koček": { sk: "Poistenie mačiek" },
  "Pojištění auta": { sk: "Poistenie auta" },
  "Animovaná stránka s kalkulačkou, příklady a poptávkovým formulářem.": { sk: "Animovaná stránka s kalkulačkou, príkladmi a dopytovým formulárom." },
  "Stránka o životním pojištění + kalkulačka pojistných částek.": { sk: "Stránka o životnom poistení + kalkulačka poistných súm." },
  "Stránka o pravidelné investici + složené úročení v reálu.": { sk: "Stránka o pravidelnom investovaní + zložené úročenie v praxi." },
  "Premium stránka s animovaným autem, porovnáním úvěru vs. operáku a daňovým poradenstvím.": { sk: "Prémiová stránka s animovaným autom, porovnaním úveru a operatívneho lízingu a daňovým poradenstvom." },
  "Rolex Green stránka pro majitele — kalkulačka výnosnosti (investice / vlastní bydlení).": { sk: "Rolex Green stránka pre majiteľov — kalkulačka výnosnosti (investícia / vlastné bývanie)." },
  "Klient sepíše 15 jmen lidí, které mi může doporučit.": { sk: "Klient spíše 15 mien ľudí, ktorých mi môže odporučiť." },
  "Pro 25–35 let — 90 % LTV, 10 % vlastních, bez ručitele.": { sk: "Pre 25–35 rokov — 90 % LTV, 10 % vlastných, bez ručiteľa." },
  "ETF pro lidi, kteří začínají. Bez kryptokurzů, bez spekulací.": { sk: "ETF pre ľudí, ktorí začínajú. Bez kryptomien, bez špekulácií." },
  "Anonymní konzultace o společném majetku, hypotéce, životce.": { sk: "Anonymná konzultácia o spoločnom majetku, hypotéke, životnom poistení." },
  // Popisy pro ČESKÝ trh (tenant CZ se slovenštinou) — koruny jsou tu správně
  "Pošli tip, dostaň 20–50 000 Kč. Rolex Green stránka pro reference z okolí.": { sk: "Pošli tip, získaj 20 – 50 000 Kč. Rolex Green stránka pre referencie z okolia." },
  "Lidem s končící fixací — porovnání 12 bank a vyčíslení úspory v Kč.": { sk: "Ľuďom s končiacou fixáciou — porovnanie 12 bánk a vyčíslenie úspory v Kč." },
  "Pro podnikatele — daňová optimalizace + důchod placený firmou.": { sk: "Pre podnikateľov — daňová optimalizácia + dôchodok platený firmou." },
  "1 500 Kč/měs → modelově ≈ 720 tis. v 18 letech dítěte + ochrana rodičů.": { sk: "1 500 Kč/mes. → modelovo ≈ 720 tis. v 18 rokoch dieťaťa + ochrana rodičov." },
  "Pro 50-65 let. Cíl renty 35 000 Kč/měs po 25 let.": { sk: "Pre 50 – 65 rokov. Cieľ renty 35 000 Kč/mes. na 25 rokov." },
  "Ochrana hypotéky pro rodinu — pojistka 1 200 Kč/měs za 4 mil. krytí.": { sk: "Ochrana hypotéky pre rodinu — poistka 1 200 Kč/mes. za krytie 4 mil." },
  "Veterina ať není loterie — krytí operací a úrazů od 180 Kč/měs. Kalkulačka dle plemene.": { sk: "Veterina nech nie je lotéria — krytie operácií a úrazov od 180 Kč/mes. Kalkulačka podľa plemena." },
  // Popisy pro SLOVENSKÝ trh (POPIS_SK_TRH — čísla z data/leadgenTopicsSk.js)
  "Pošli tip, dostaň až 1 % z kupní ceny. Rolex Green stránka pro reference z okolí.": { sk: "Pošli tip, získaj až 1 % z kúpnej ceny. Rolex Green stránka pre referencie z okolia." },
  "Lidem s končící fixací — porovnání 10+ bank a vyčíslení úspory v eurech.": { sk: "Ľuďom s končiacou fixáciou — porovnanie 10+ bánk a vyčíslenie úspory v eurách." },
  "Pro podnikatele — daňová optimalizace, důchod a ochrana příjmu v jednom plánu.": { sk: "Pre podnikateľov — daňová optimalizácia, dôchodok a ochrana príjmu v jednom pláne." },
  "60 €/měs. → téměř 29 000 € v 18 letech dítěte + ochrana rodičů.": { sk: "60 €/mes. → takmer 29 000 € v 18 rokoch dieťaťa + ochrana rodičov." },
  "Ochrana hypotéky pro rodinu — typicky ~48 €/měs. za krytí hypotéky 160 000 €.": { sk: "Ochrana hypotéky pre rodinu — typicky ~48 €/mes. za krytie hypotéky 160 000 €." },
  "Veterina ať není loterie — krytí operací a úrazů od pár eur měsíčně. Kalkulačka dle plemene.": { sk: "Veterina nech nie je lotéria — krytie operácií a úrazov od pár eur mesačne. Kalkulačka podľa plemena." },
  // Rodinný rozpočet do detailu (25. 10. 2026) — karta pro CZ i SK
  "Tabulka výdajů do detailu — klient si spočítá, kolik mu měsíčně zbývá, a pošle součty s poptávkou.": { sk: "Tabuľka výdavkov do detailu — klient si spočíta, koľko mu mesačne zostáva, a pošle súčty s dopytom." },

  /* ── Metodika — tištěný certifikát (MetodikaAkademiePage) ── */
  "Metodická akademie": { sk: "Metodická akadémia" },
  "Certifikát o absolvování": { sk: "Certifikát o absolvovaní" },
  "Sestavení finančního plánu podle metodiky (Syrový / Tyl)": { sk: "Zostavenie finančného plánu podľa metodiky (Syrový / Tyl)" },
  "úspěšně dokončil(a) všech 7 modulů a závěrečnou zkoušku.": { sk: "úspešne dokončil(a) všetkých 7 modulov a záverečnú skúšku." },
  "Výsledek zkoušky:": { sk: "Výsledok skúšky:" },
};
